
<div class="card">
  <div class="card-body">
    <a [routerLink]="'/devices'" [queryParams]="{tab: 'scanner'}" class="card-title h5">
      <span class="material-symbols-outlined">devices</span>
      <span style="vertical-align: middle;" class="ms-2">{{configuration.title}}</span>
    </a>
    @if (configuration.description) {
      <h6 class="card-subtitle mb-2 mt-2 text-muted">{{configuration.description}}</h6>
    }
    @if (!isLoading) {
      <app-card-bar [title]="'scanner.title'" [data]="smartwatchData"></app-card-bar>
    }
    <app-loading-indicator [loading]="isLoading"></app-loading-indicator>
  </div>
</div>
